export const GET_CLOVER_STATUS = "GET_CLOVER_STATUS"
export const GET_CLOVER_MESSAGE = "GET_CLOVER_MESSAGE"

export const GET_CLOVER_SETTING_STARTED = "GET_CLOVER_SETTING_STARTED"
export const GET_CLOVER_SETTING_SUCCESS = "GET_CLOVER_SETTING_SUCCESS"
export const GET_CLOVER_SETTING_FAILURE = "GET_CLOVER_SETTING_FAILURE"

export const UPDATE_CLOVER_SETTING_STARTED = "UPDATE_CLOVER_SETTING_STARTED"
export const UPDATE_CLOVER_SETTING_SUCCESS = "UPDATE_CLOVER_SETTING_SUCCESS"
export const UPDATE_CLOVER_SETTING_FAILURE = "UPDATE_CLOVER_SETTING_FAILURE"


export const UPDATE_CLOVER_AUTH_TOKEN_STARTED = "UPDATE_CLOVER_AUTH_TOKEN_STARTED"
export const UPDATE_CLOVER_AUTH_TOKEN_SUCCESS = "UPDATE_CLOVER_AUTH_TOKEN_SUCCESS"
export const UPDATE_CLOVER_AUTH_TOKEN_FAILURE = "UPDATE_CLOVER_AUTH_TOKEN_FAILURE"

export const SET_DEFAULT_DEVICE_WIFI_CLOVER_STARTED = "SET_DEFAULT_DEVICE_WIFI_CLOVER_STARTED"
export const SET_DEFAULT_DEVICE_WIFI_CLOVER_SUCCESS = "SET_DEFAULT_DEVICE_WIFI_CLOVER_SUCCESS"
export const SET_DEFAULT_DEVICE_WIFI_CLOVER_FAILURE = "SET_DEFAULT_DEVICE_WIFI_CLOVER_FAILURE"

export const DISCONNECT_CLOVER_WIFI_STARTED = "DISCONNECT_CLOVER_WIFI_STARTED"
export const DISCONNECT_CLOVER_WIFI_SUCCESS = "DISCONNECT_CLOVER_WIFI_SUCCESS"
export const DISCONNECT_CLOVER_WIFI_FAILURE = "DISCONNECT_CLOVER_WIFI_FAILURE"

export const REMOVE_ERROR_MESSAGE = "REMOVE_ERROR_MESSAGE"
